import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from "../pages/common/NotFound.jsx";
import Signup from "../pages/auth/signup.jsx";
import VerifyOTP from "../pages/auth/verifyOTP.jsx";
import Login from "../pages/auth/login.jsx";
import ResetPassword from "../pages/auth/resetPassword.jsx";
import ResetPasswordVerifyOtp from "../pages/auth/resetPasswordVerifyOTP.jsx";
import PublicRoute from "./PublicRoute.jsx";
import AuthInitializer from "../app/AuthInitializer.jsx";
import AppLayout from "../layouts/AppLayout.jsx";
import Home from "../pages/common/home.jsx";
import Visualizations from "../pages/common/visualizations.jsx";
import VisualizationDetail from "../pages/common/visualizationDetail.jsx";
import ProtectedRoute from "./ProtectedRoute.jsx";
import CreateVisualization from "../pages/studio/visualization/createVisualization.jsx";
import StudioLayout from "../layouts/StudioLayout.jsx";
import UpdateVisualization from "../pages/studio/visualization/updateVisualization.jsx";
import MyProfile from "../pages/user/MyProfile.jsx";
import Profile from "../pages/user/Profile.jsx";
import Settings from "../pages/user/Settings.jsx";
import ExportPage from "../pages/studio/ExportPage.jsx";
import MyAccess from "../pages/user/MyAccess.jsx";
import AdminDashboard from "../pages/studio/AdminDashboard.jsx";
import AdminRoute from "./AdminRoute.jsx";
import Privacy from "../pages/legal/Privacy.jsx";
import Terms from "../pages/legal/Terms.jsx";
import About from "../pages/common/about.jsx";
import Animations from "../pages/studio/animation/Animations.jsx";
import MyVisualizations from "../pages/studio/visualization/MyVisualizations.jsx";
import Studio from "../pages/studio/studio.jsx";
import ScrollToTop from "../components/common/ScrollToTop.jsx";
import SiteAnalyticsTracker from "../components/common/SiteAnalyticsTracker.jsx";
import VisualizationsPage from "../pages/common/visualizationsPage.jsx";
import FolderPage from "../pages/studio/folderPage.jsx";
import NewAnimationEditor from "../pages/studio/animation/NewAnimationEditor.jsx";
import Errors from "../pages/studio/errors.jsx";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <AuthInitializer>
        <SiteAnalyticsTracker />
        <ScrollToTop />
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-otp" element={<VerifyOTP />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/reset-password-verify-otp"
              element={<ResetPasswordVerifyOtp />}
            />
          </Route>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/visualizations" element={<Visualizations />} />
            <Route
              path="/f/visualizations/*"
              element={<VisualizationsPage />}
            />
            <Route
              path="/v/visualizations/*"
              element={<VisualizationDetail />}
            />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route element={<AdminRoute />}>
                <Route path="/errors" element={<Errors />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Route>
              <Route path="/studio" element={<Studio />} />
              <Route
                path="/studio/visualizations"
                element={<MyVisualizations />}
              />
              <Route path="/studio/folders/*" element={<FolderPage />} />
              <Route path="/studio/animations" element={<Animations />} />
              <Route path="/profile/me" element={<MyProfile />} />
              <Route path="/profile/:userId" element={<Profile />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/my-access" element={<MyAccess />} />
            </Route>
            <Route element={<StudioLayout />}>
              <Route
                path="/studio/visualizations/new"
                element={<CreateVisualization />}
              />
              <Route
                path="/studio/visualizations/:publicationId"
                element={<UpdateVisualization />}
              />
            </Route>
            <Route
              path="/studio/animations/new"
              element={<NewAnimationEditor />}
            />
            <Route
              path="/studio/animations/:animationId"
              element={<NewAnimationEditor />}
            />
            <Route path="/export/:jobId" element={<ExportPage />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthInitializer>
    </BrowserRouter>
  );
};

export default AppRouter;
